import { useMemo } from "react";
import { tableConfigs } from "../constants";

const TABLE_KEYS_BY_TAB = {
  summary: ["byDaysLate", "byReason"],
  geo: [
    "byFromState",
    "byToState",
    "byFromStateAndCompany",
    "byToStateAndMetroRegional",
    "top10BestLanes",
    "top10WorstLanes",
  ],
  freight: [
    "byServiceType",
    "byService",
    "byCarrierAndService",
    "top10KnownReceivers",
    "top10ReceiversCompletedAndReportable",
    "top20Senders",
  ],
  timePeriod: ["byFyMonth", "byFyQuarter"],
};

export function useVisibleTables(activeTab) {
  return useMemo(() => {
    const keys = TABLE_KEYS_BY_TAB[activeTab];
    if (!keys) return [];
    return tableConfigs.filter((config) => keys.includes(config.key));
  }, [activeTab]);
}
